<template>
  <div class="personLocation">
    <el-button
      v-if="showButton"
      round
      type="primary"
      icon="el-icon-location-outline"
      @click="openPersonLocationMap"
      v-show="hasPermission('人员定位')"
      >{{ $l(label) }}
    </el-button>
    <el-dialog
      :title="personnelPositionDialogTitle"
      :visible.sync="personLocationDialogVisible"
      :width="width"
      :close-on-click-modal="closeOnClickModal"
      v-loading.lock="personnelPositionLoading"
      :element-loading-text="$l('正在加载中')"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <div :style="{ position: 'relative', height: height }">
        <mapPersonList
          :data="personList"
          :status="personLoadingStatus"
        ></mapPersonList>
        <div id="personLocationMap" :style="{ height: height }"></div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="showTrace"
      :title="$l('人员轨迹')"
      :visible.sync="personTraceDialogVisible"
      :close-on-click-modal="closeOnClickModal"
      v-loading.lock="personnelPositionLoading"
      :element-loading-text="$l('正在加载中')"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <div id="personTraceMap" :style="{ height: height }"></div>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
import mapPersonList from "@/components/mapPersonList.vue";
import loadBMap from "@/utils/loadBMap";

export default {
  name: "personLocation",
  mixins: [global],
  components: {
    mapPersonList,
  },
  props: {
    selectedList: {
      type: Array,
      default: () => [],
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showTrace: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "人员定位",
    },
    width: {
      type: String,
      default: "50%",
    },
    height: {
      type: String,
      default: "400px",
    },
    icon: {
      type: String,
      default: "",
    },
    emptyCoordMsg: {
      type: String,
      default: "电梯坐标不存在",
    },
  },
  data() {
    return {
      personnelPositionLoading: false,
      personLocationDialogVisible: false,
      personTraceDialogVisible: false,
      closeOnClickModal: false,
      position: {
        x: 0,
        y: 0,
        newX: 0,
        newY: 0,
      },
      personnelPositionDialogTitle: "",
      personList: [],
      personLoadingStatus: -1,
    };
  },
  methods: {
    drawElevatorLocation(id) {
      return loadBMap().then((BMap) => {
        let map = new BMap.Map(id);
        const centerPoint = new BMap.Point(
          this.position.newX,
          this.position.newY
        );
        map.centerAndZoom(centerPoint, 17);
        var elevatorIcon = new BMap.Icon(
          this.icon || require("../assets/img/elevator.png"),
          new BMap.Size(32, 37)
        );
        map.addOverlay(new BMap.Marker(centerPoint, { icon: elevatorIcon }));
        return { map, BMap };
      });
    },
    openPersonLocationMap() {
      const len = this.selectedList.length;
      if (len != 1) {
        this.message(1, "请选择一条数据");
        return;
      }
      this.open(this.selectedList[0]);
    },
    open(row) {
      if (!window.config.baiduAK) {
        this.message(0, "地图维护中...");
        return;
      }
      if (!row.x || !row.y) {
        this.message(1, this.emptyCoordMsg);
        return;
      }
      this.personnelPositionDialogTitle = this.$l(this.label);
      this.position.x = row.x;
      this.position.y = row.y;
      this.position.newX = row.x;
      this.position.newY = row.y;
      this.personLocationDialogVisible = true;
      this.personList = [];
      this.drawElevatorLocation("personLocationMap").then(({ map, BMap }) => {
        this.getPersonPosition(map, BMap);
      });
    },
    getPersonPosition(map, BMap) {
      this.personLoadingStatus = 0;
      this.$http
        .get(this.$apiConfig.get_personnel_position_url, {
          params: {
            longitude: this.position.x,
            latitude: this.position.y,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            const datas = result.data;
            this.personList = datas;
            this.personLoadingStatus = this.personList.length == 0 ? -1 : 1;
            if (datas && datas.length > 0) {
              this.personnelPositionDialogTitle += `(离电梯最近有${
                datas.length > 3 ? 3 : datas.length
              }人)`;
              datas.forEach((item) => {
                const point = new BMap.Point(item.dimension, item.latitude);
                const marker = new BMap.Marker(point, {
                  icon: new BMap.Icon(
                    require("../assets/img/man_walk.png"),
                    new BMap.Size(32, 32)
                  ),
                });
                if (this.showTrace) {
                  marker.addEventListener("click", () => {
                    this.openPersonTraceMap(item.userId, point);
                  });
                }
                map.addOverlay(marker);
              });
            }
          } else {
            this.personLoadingStatus = -1;
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.personLoadingStatus = -1;
          this.$sentry.captureException(error);
        });
    },
    openPersonTraceMap(userId, point) {
      this.personnelPositionLoading = true;
      this.$http
        .get(this.$apiConfig.get_personnel_track_url, {
          params: {
            userId: userId,
            startTime: "2019-08-01 00:00:00",
            endTime: this.$common.formatCurrentDateTime(),
          },
        })
        .then((response) => {
          this.personnelPositionLoading = false;
          const result = response.data;
          if (result.code == 0) {
            this.personTraceDialogVisible = true;
            const datas = result.data;
            this.drawElevatorLocation("personTraceMap").then(
              ({ map, BMap }) => {
                const marker = new BMap.Marker(point, {
                  icon: new BMap.Icon(
                    require("../assets/img/man_walk.png"),
                    new BMap.Size(76, 76)
                  ),
                });
                map.addOverlay(marker);
                if (datas && datas.length > 0) {
                  const points = [point];
                  datas.forEach((item) => {
                    points.push(new BMap.Point(item.dimension, item.latitude));
                  });
                  if (points.length > 0) {
                    const polyline = new BMap.Polyline(points, {
                      enableEditing: false,
                      enableClicking: false,
                      strokeWeight: "8",
                      strokeOpacity: 0.8,
                      strokeColor: "#18a45b",
                    });
                    map.addOverlay(polyline);
                  }
                }
              }
            );
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.personnelPositionLoading = false;
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.personLocation {
  display: inline-block;
  /deep/ .el-dialog__header {
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding: 1px;
  }
  /deep/ .anchorBL {
    display: none;
  }
}
</style>
